module.exports = __webpack_public_path__ + "img/ECO.76d7da94.svg";